import { API_BASE_URL, API_PATHS, getApiPaths } from "../utils/constants/api.constants";
import axiosInstance from "../utils/authUtils";


class StaffService {

    static getStaff(item) {

        let api = `${API_BASE_URL}${API_PATHS.getstaff}`;

        const params = new URLSearchParams();

        if (item?.page) params.append("page", item.page);
        if (item?.limit) params.append("limit", item.limit);
        if (item?.id) params.append("id", item.id);
       
        if ([...params].length > 0) {
            api += `?${params.toString()}`;
        }

        return axiosInstance.get(api,item);
    }

    static addStaff(data) {
        let api = '';
        api = `${API_BASE_URL}${API_PATHS.addstaff}`;
        return axiosInstance
            .post(api, data)

    }

    static editStaff(data) {

        let api = '';
        api = `${API_BASE_URL}${API_PATHS.editstaff}`;
        return axiosInstance
            .put(api, data)

    }

    static deleteStaff(id) {
        let api = '';

        api = `${API_BASE_URL}${API_PATHS.deletestaff}?id=${id}`;

        return axiosInstance
            .delete(api)
    }


}

export default StaffService;
